import React from 'react'
import { useTranslation } from 'react-i18next'

import { FieldProps } from '../../../../../../../@types/types'
import { OtherFacilitiesScreenValidationResult } from '../../../../../../../@types/validation-types'
import { TextInput } from '../../../../../../common/inputs/textInput/TextInput'
import { getDefaultClasses } from '../../../../../../../utils/style-utils'

const MinRentalTime: React.FC<FieldProps<OtherFacilitiesScreenValidationResult>> = ({
  screenName,
  insertionData,
  validationMessages,
  onChange,
  wrapperClassName = getDefaultClasses('left'),
}) => {
  const { t } = useTranslation()
  return (
    <div className={wrapperClassName}>
      <TextInput
        id='min-rental-time'
        propertyName='minRentalTime'
        placeholder=''
        label={<span>{t('wizard.screen.otherFacilities.minRentalTime', 'min Rental Time')}</span>}
        value={insertionData.minRentalTime}
        maxLength={3}
        type='text'
        affixRight='icon'
        iconRight={
          <span className={'font-body-large-regular'}>{t('wizard.screen.otherFacilities.placeholder.months')}</span>
        }
        errors={validationMessages!.minRentalTime ?? []}
        doOnFieldChange={(property, value) => onChange({ screen: screenName, property }, value)}
      />
    </div>
  )
}
export default MinRentalTime
